import { useLanguage } from "@/lib/i18n";

const PHONE = "971542184086";

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(t("whatsapp.message"))}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label={t("whatsapp.label")}
      className="fixed bottom-6 end-6 z-50 w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-black/20 hover:scale-110 transition-transform duration-300 flex items-center justify-center"
    >
      <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white" aria-hidden="true">
        <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.646.867 5.096 2.334 7.078L4.062 28.5a.75.75 0 0 0 .938.938l6.418-2.272a11.93 11.93 0 0 0 4.586.912C22.625 28.078 28 22.695 28 16.074 28 8.867 22.625 3 16.004 3zm0 2.25c5.383 0 9.746 4.77 9.746 10.824 0 5.383-4.363 9.754-9.746 9.754a9.67 9.67 0 0 1-4.184-.945.75.75 0 0 0-.57-.035l-4.535 1.605 1.594-4.457a.75.75 0 0 0-.098-.688 9.68 9.68 0 0 1-1.961-5.804c0-5.383 4.371-10.254 9.754-10.254zm-3.746 5.02c-.246 0-.645.09-.984.457-.336.363-1.285 1.254-1.285 3.058 0 1.805 1.316 3.551 1.5 3.797.18.246 2.54 4.055 6.27 5.527 3.098 1.223 3.727.98 4.398.918.672-.058 2.168-.886 2.473-1.742.305-.855.305-1.59.215-1.742-.09-.153-.336-.246-.703-.43-.368-.183-2.168-1.07-2.504-1.191-.336-.121-.582-.184-.828.183-.246.368-.949 1.192-1.164 1.438-.215.246-.43.277-.797.093-.367-.183-1.547-.57-2.945-1.816-1.09-.972-1.824-2.172-2.04-2.539-.214-.367-.022-.566.161-.75.166-.164.368-.43.551-.644.184-.215.246-.368.368-.614.121-.246.06-.46-.031-.644-.09-.184-.828-1.996-1.133-2.734-.297-.719-.602-.622-.828-.633-.215-.01-.46-.012-.694-.012z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
